import request from './request'
import * as http from '@/libs/http'

/**
 * 新しい予約を追加する
 *
 * @param {Number} uid ユーザID
 * @param {Object} reserve 予約情報
 * @returns {Response} レスポンスデータ
 */
export function newReserve (uid, reserve) {
  return request.post(`/users/${uid}/reserves`, reserve, {
    validateStatus: (status) => [
      http.Created,
      http.Conflict,
      http.BadRequest
    ].includes(status)
  })
}
